import { render, staticRenderFns } from "./ModuleUpdate.vue?vue&type=template&id=95aaa824&scoped=true&"
import script from "./ModuleUpdate.vue?vue&type=script&lang=js&"
export * from "./ModuleUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ModuleUpdate.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ModuleUpdate.vue?vue&type=style&index=1&id=95aaa824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95aaa824",
  null
  
)

export default component.exports